export default __webpack_public_path__ + "static/media/profile-exit.c8c8aebf.svg";